import React, { useEffect, useRef, useState } from "react";
import { getGameEvents } from "../data/gameEvents";
import './gameevent.css'
import { useSubscription } from "../../../../hooks/useSubscription";
import { useDirect } from "../DirectContext";
import { Box, Button, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

const GameEventButtons = ({ discipline, onEventClick }) => {

  const directEvent = useDirect()
  const { checkSubscription } = useSubscription(directEvent)
  const events = getGameEvents(discipline);

  const containerRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState("none");

  const [hoveredIndex, setHoveredIndex] = useState(null);

  const [showAll, setShowAll] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);

  /**
   * CONTAINER DISPLAY CALCULATION
   * max 2 rows - responsive
   */
  useEffect(() => {
    function limitToTwoRows() {
      const container = containerRef.current;
      if (!container) return;

      const items = Array.from(container.children);
      if (items.length === 0) return;

      // Regrouper les items par lignes
      const lineTops = new Set();
      for (let item of items) {
        lineTops.add(item.offsetTop);
      }

      const lineCount = lineTops.size;

      if (lineCount > 2) {
        const lineTopsArray = [...lineTops].sort((a, b) => a - b);
        const firstRowTop = lineTopsArray[0];
        const secondRowTop = lineTopsArray[1];

        const firstRowItems = items.filter(i => i.offsetTop === firstRowTop);
        const secondRowItems = items.filter(i => i.offsetTop === secondRowTop);

        const firstRowBottom = Math.max(...firstRowItems.map(i => i.offsetTop + i.offsetHeight));
        const secondRowBottom = Math.max(...secondRowItems.map(i => i.offsetTop + i.offsetHeight));

        const twoRowsHeight = secondRowBottom - firstRowTop;

        setMaxHeight(`${twoRowsHeight}px`);
        setIsOverflowing(true);
      } else {
        setMaxHeight("none");
        setIsOverflowing(false);
      }
    }

    limitToTwoRows();
    window.addEventListener("resize", limitToTwoRows);
    return () => window.removeEventListener("resize", limitToTwoRows);
  }, [events]);

  const visibleStyle = {
    maxHeight: showAll ? "none" : maxHeight,
    overflow: "hidden",
    display: "flex",
    flexWrap: "wrap",
    transition: "max-height 0.3s ease"
  };


 return (
    <>
      <div className="buttons-container" ref={containerRef} style={visibleStyle}>
        {events.filter(e => checkSubscription(e.subscription)).map((event, idx) => (
          <Box key={idx} className="xs-padding">
            <Button
              className="event-button bordered-wrapper"
              sx={{
                minWidth: '135px',
                backgroundColor: "var(--color-white)",
                border: "1px solid var(--color-light-grey)",
                borderRadius: "8px",
                color: "var(--color-text)",
                "&:hover": {
                  backgroundColor: "var(--color-white)",
                  color: "var(--color-blue-primary)",
                  borderColor: "var(--color-blue-primary)",
                },
                "&:hover .MuiTypography-root": {
                  color: "var(--color-blue-primary)",
                },
              }}
              onClick={() => onEventClick(event)}
              onMouseEnter={() => setHoveredIndex(idx)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <img
                src={
                  hoveredIndex === idx && event.picto?.blue
                    ? event.picto.blue
                    : event.picto?.standard || event.img
                }
                alt={event.label}
              />
              <Typography fontSize="14px" color="var(--color-text)">{event.label}</Typography>
            </Button>
          </Box>
        ))}
      </div>

      {/* Bouton afficher plus/moins */}
      {isOverflowing && (
        <Box mt={1} display="flex" justifyContent="center">
          <Button
            size="small"
            onClick={() => setShowAll(prev => !prev)}
            variant="text"
            sx={{ color: "var(--color-blue-primary)", 
              fontSize: "14px",
              "&:hover": {
                  backgroundColor: "var(--color-white)",
                },
              "& svg": {
                  paddingLeft: "7px",
                  fontSize: "16px",
                  transform: "scale(1.2)", // effet "bold"
                },
            }}
          >
            <Typography sx={{ paddingTop: showAll ? 0 : "3px" }}>
              {showAll ? "Afficher moins" : "Afficher plus"}
            </Typography>
            <FontAwesomeIcon icon={showAll ? faChevronUp : faChevronDown}/>
          </Button>
        </Box>
      )}
    </>
  );
};

export default GameEventButtons;